import { Injectable, computed, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private readonly router = inject(Router);
  private readonly manualOverride = signal<boolean | null>(null);

  private readonly routeFramed = toSignal(
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => {
        const url = event.urlAfterRedirects || event.url;
        return !url.startsWith('/admin');
      })
    ),
    {
      initialValue: !this.router.url.startsWith('/admin')
    }
  );

  readonly isFramed = computed(() => {
    const override = this.manualOverride();
    if (override !== null) {
      return override;
    }
    return this.routeFramed();
  });

  setFramed(framed: boolean) {
    this.manualOverride.set(framed);
  }

  resetOverride() {
    this.manualOverride.set(null);
  }

  enableFraming() {
    this.manualOverride.set(true);
  }

  disableFraming() {
    this.manualOverride.set(false);
  }
}
